import { createUseStyles } from "react-jss";
import * as Mixins from "../../../theme/Mixins";

export default createUseStyles({
    imageChoice: {
        composes: "image-choice",
        margin: ({ theme }) => [[Mixins.getSpacing(theme, theme.ChoiceSpacing, theme.QuestionSpacing?.WithinComponents), Mixins.getSpacing(theme, theme.ChoiceSpacing, theme.QuestionSpacing?.WithinComponents) / 4]],
        textAlign: "center",
        userSelect: "none",
    },
    imageChoiceCollapsed: {
        composes: "image-choice-collapsed",
        flexDirection: "row",
        justifyContent: "start",
        margin: ({ theme }) => [[0, 0, Mixins.getSpacing(theme, theme.ChoiceSpacing, theme.QuestionSpacing?.WithinComponents), 0]],
    },
    imageChoiceTarget: {
        background: ({ theme }) => theme.ControlBackground,
        border: ({ theme }) => [[theme.BorderWidth, "solid", theme.ControlBorderColor]],
        borderRadius: ({ theme }) => theme.BorderRadius,
        composes: "image-choice__target",
        fontSize: 0,
        lineHeight: 0,
        cursor: "pointer",
        outline: "none",
        overflow: "hidden",
        position: "relative",
        verticalAlign: "middle",
    },
    imageChoiceOverlay: {
        bottom: 0,
        composes: "image-choice__overlay",
        left: 0,
        position: "absolute",
        right: 0,
        top: 0,
        transition: "background 200ms",
    },
    imageChoiceOverlaySelected: {
        background: ({ theme }) => Mixins.alpha(theme.PrimaryColor, 0.3),
        composes: "image-choice__overlay--selected",
    },
    imageChoiceOverlayActive: {
        background: ({ theme, selected }) =>
            selected ? Mixins.alpha(theme.PrimaryColor, 0.5) : Mixins.alpha("#999", 0.5),
        composes: "image-choice__overlay--active",
    },
    imageChoiceImage: {
        height: "100%",
        width: "100%",
    },
    imageChoiceText: {
        display: "inline-block",
        composes: "image-choice__text",
        cursor: "pointer",
        textAlign: "left",
        lineHeight: ({ theme }) => `${theme.LineHeight}px`,
        marginTop: 9.67,
    },
    imageChoiceCollapsedText: {
        composes: "image-choice-collapsed__text",
        margin: [[0, 9.67]],
    },
    imageChoiceTextSelected: {
        fontWeight: "bolder",
        color: ({ theme }) => theme.PrimaryColor,
    },
    imageDisabled: {
        opacity: 0.5,
        pointerEvents: "none",
    },
});
